export default __webpack_public_path__ + "static/media/05_Kom_Oxford A2.75a2a416.jpg";